import React from 'react';
import { preventInputBlurOnPointerDown } from '../../utils/mobileSearchInput';

/** Split a search string into first/last name for guest prefill. */
export function parseSearchToGuestName(search) {
  const trimmed = (search || '').trim();
  if (!trimmed) return { firstName: '', lastName: '' };
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) return { firstName: parts[0], lastName: '' };
  return { firstName: parts[0], lastName: parts.slice(1).join(' ') };
}

export function AddNewGuestRow({ search, onAddNewGuest, className = '' }) {
  const trimmed = search.trim();
  const { firstName, lastName } = parseSearchToGuestName(search);
  const displayName = trimmed || 'new guest';

  const activate = () => {
    onAddNewGuest({ firstName, lastName, searchQuery: trimmed });
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onMouseDown={preventInputBlurOnPointerDown}
      onClick={activate}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate();
        }
      }}
      className={`flex w-full items-center justify-between gap-2 rounded-lg border border-dashed border-primary/40 bg-primary/5 p-3 min-h-[44px] touch-manipulation text-left transition-colors cursor-pointer hover:bg-primary/10 ${className}`}
    >
      <span className="min-w-0 flex-1 text-sm text-text-primary">
        {trimmed ? (
          <>
            No player found — add{' '}
            <span className="font-medium text-primary">&ldquo;{displayName}&rdquo;</span> as new guest
          </>
        ) : (
          <span className="font-medium text-primary">Add new guest player</span>
        )}
      </span>
      <span className="shrink-0 text-xs font-medium text-primary">Add guest</span>
    </div>
  );
}
